import React from 'react';
import { Typography } from '@mui/material';
import { JsonView, allExpanded } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

export const TitanConfigView = ({ titanConfigData, errorMessage }) => (
    <div className="titan-config-section">
        <Typography variant="h6" className="section-title">Titan Configuration</Typography>
        {titanConfigData ? (
            <JsonView
                data={titanConfigData}
                shouldExpandNode={allExpanded}
                theme="dark"
                className="json-viewer"
            />
        ) : (
            <Typography color="error" className="error-message">
                {errorMessage}
            </Typography>
        )}
    </div>
);